export const podMenuConfig = [
  {
    id: 'HOTEL_INFO',
    name: 'Informacje Hotelowe',
  },
  {
    id: 'SPECIAL_OFFER',
    name: 'Oferty specjalne',
  },
  {
    id: 'LEAVE_OPINION',
    name: 'Opinie',
  },
  {
    id: 'WIFI',
    name: 'Wifi',
  },
  {
    id: 'NEARBY',
    name: 'W pobliżu',
  },
  {
    id: 'SOCIAL_MEDIA',
    name: 'Social Media',
  },
  {
    id: 'VIRTUAL_TOUR',
    name: 'Wirtualny spacer',
  },
  {
    id: 'LOYALTY',
    name: 'Program lojalnościowy',
  },
  {
    id: 'HOTEL_EVENTS',
    name: 'Wydarzenia hotelowe',
  },
  {
    id: 'TAXI',
    name: 'Zamów taksówkę',
  },
  {
    id: 'RENT',
    name: 'Wypożyczalnia',
  },
  {
    id: 'OTHER_ITEMS',
    name: 'Pełne menu',
  },
  {
    id: 'GOOD_PRACTICES',
    name: 'Dobra praktyka',
  },
  {
    id: 'REGULATION',
    name: 'Regulaminy',
  },
  {
    id: 'PHONEBOOK',
    name: 'Ks. Telefoniczna',
  },
];

export const defaultMenuSettings = {
  homeScreen: [
    'SOCIAL_MEDIA',
    'LEAVE_OPINION',
    'HOTEL_INFO',
    'SPECIAL_OFFER',
    'WIFI',
    'OTHER_ITEMS',
  ],
  welcomeScreen: [
    'WIFI',
    'NEARBY',
    'HOTEL_INFO',
  ],
  slideMenu: [
    'HOTEL_INFO',
    'SPECIAL_OFFER',
    'LEAVE_OPINION',
    'NEARBY',
    'WIFI',
    'RENT',
    'VIRTUAL_TOUR',
    'SOCIAL_MEDIA',
    'LOYALTY',
    'HOTEL_EVENTS',
    'GOOD_PRACTICES',
  ],
};
